import { VersionRange } from '../../models/core/version-range.js';
import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { PhotoCollection } from '../../models/serializable/photo-collection.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class ProfilePhotosComponent extends Component {
  static readonly TYPE_ID: string = '24fd01fc9daa474a96f57ca558179391';
  static readonly SCHEMA_VERSION: number = 2;

  constructor(
    public readonly portfolio: PhotoCollection,
  ) {
    super();
  }

  get $typeId(): string {
    return ProfilePhotosComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  get $schemaVersion(): VersionRange {
    return VersionRange.exactly(ProfilePhotosComponent.SCHEMA_VERSION);
  }

  static fromMap(context: SerializationContext, map: SerializedData): ProfilePhotosComponent {
    return new ProfilePhotosComponent(
        context.fromData<PhotoCollection>(MapUtils.getRaw(map, 'portfolio') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'portfolio': context.toData(this.portfolio),
    };
  }

  clone(): this {
    return new ProfilePhotosComponent(
        this.portfolio.clone(),
    ) as this;
  }

  isSame(other: ProfilePhotosComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.portfolio, this.portfolio);
  }
}

export class ProfilePhotosComponentBuilder extends DataModelBuilder<ProfilePhotosComponent> {
  build(context: SerializationContext, map: SerializedData): ProfilePhotosComponent {
    return ProfilePhotosComponent.fromMap(context, map);
  }

  migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    const versionRange = MapUtils.getVersionRange(map);
    if(versionRange.contains(ProfilePhotosComponent.SCHEMA_VERSION)) {
      return map;
    }
    if(versionRange.isGreaterThan(ProfilePhotosComponent.SCHEMA_VERSION)) {
      return null; // This data comes from the FUTURE. We have no idea how to migrate it.
    }

    let version = versionRange.to;

    if(version < 2) {
      MapUtils.set(map, 'portfolio', MapUtils.get(map, 'photos'));
      version = 2;
    }

    map['$schema_version'] = VersionRange.encodedExactly(version);
    return map;
  }
}
